import { EventSubscription } from 'fbemitter';

export function removeListener(listener: EventSubscription | null) {
  if (listener !== null) {
    listener.remove();
  }
}

export function assignmentToString(a: Assignment): string {
  if (a.assignmentType === 0) {
    return 'Assignment not yet available';
  } else if (a.assignmentType === 1) {
    return 'Not in pool';
  }

  let output = a.assignment;
  if (a.author !== undefined && a.author !== '') {
    output += ' ' + a.author;
  }
  if (a.part !== undefined && a.part !== '0') {
    output += ': Part ' + a.part;
  }
  if (a.meNote !== undefined && a.part !== '') {
    output += ' ' + a.meNote;
  }
  return output;
}



// WEBPACK FOOTER //
// ./src/utils.ts